import { connect } from 'react-redux';
import { getFolderStream, getHasOnlyOneChunkOfGroupFoldersToLoad } from '../../redux/selectors';
const mapStateToProps = (state, ownProps)=>{
    const { streamId, folders, isFetching, hasMore } = getFolderStream(state, ownProps.deviationId, ownProps.submissionType, ownProps.groupId);
    const hasOnlyOneChunkOfGroupFoldersToLoad = getHasOnlyOneChunkOfGroupFoldersToLoad(state, ownProps.submissionType, ownProps.groupId);
    return {
        streamId,
        folders,
        isFetching,
        hasMore,
        hasOnlyOneChunkOfGroupFoldersToLoad
    };
};
export default connect(mapStateToProps);

//# sourceMappingURL=FolderList.container.js.map